import axiosInstance from '../axiosConfigCMS';

export default {
  async getPrivacy() {
    const response = await axiosInstance.get('/privacy');
    return response.data;
  },
  async getTerms() {
    const response = await axiosInstance.get('/terms-conditions');
    return response.data;
  },
};
